/**
 * src/components/landing/FullScreenDropOverlay.tsx
 * =============================================================================
 * Overlay a pantalla completa que aparece cuando el usuario arrastra un PDF
 * sobre cualquier parte de la landing. Mensaje grande "Suelta tu PDF aquí" +
 * fondo semi-transparente que cubre todo.
 *
 * NO captura el drop por sí mismo — eso lo hace `useFullScreenDrop` desde
 * window. Este componente es puramente visual.
 * =============================================================================
 */

import { useTranslation } from 'react-i18next'
import { Upload } from 'lucide-react'

export function FullScreenDropOverlay() {
  const { t } = useTranslation()
  return (
    <div
      // `pointer-events-none`: el overlay no debe interceptar el drop, ni
      // bloquear el cursor — es solo decoración visual sobre los listeners
      // de window que ya están escuchando.
      className="fixed inset-0 z-40 pointer-events-none flex items-center justify-center bg-zinc-900/40 backdrop-blur-sm"
    >
      <div className="bg-white rounded-2xl border-2 border-dashed border-zinc-300 px-14 py-10 flex flex-col items-center gap-3 shadow-2xl">
        <Upload className="h-10 w-10 text-zinc-700" strokeWidth={1.5} />
        <p className="text-lg font-medium text-zinc-900">
          {t('landing.dropOverlay')}
        </p>
      </div>
    </div>
  )
}
